<template>
  <div class="content">
    <button
      v-if="!$parent.port"
      @click="$parent.resetType()"
      class="secondary setting"
    >
      <awesomeIcon icon="edit" /> Wijzigen
    </button>
    <h2 class="title">
      <awesomeIcon icon="suitcase"/>
      Bedrijf
    </h2>

    <div class="flex-container flex-grow">
      <customInput
        v-model="modelValue.bedrijfsnaam"
        type="text"
        label="Bedrijfsnaam"
      />
      <customInput
        v-model="modelValue.rechtsvorm"
        type="dropdown"
        label="Rechtsvorm"
        :options="$parent.rechtsvormen"
      />
    </div>
    <div class="flex-container flex-grow">
      <customInput
        v-if="modelValue.rechtsvorm === 'anders'"
        v-model="modelValue.rechtsvormAnders"
        type="text"
        label="Naam rechtsvorm"
      />
    </div>
    <div class="flex-container flex-grow">
      <customInput
        v-model="modelValue.kvk"
        type="text"
        label="KVK-nummer"
      />
      <customInput
        v-model="modelValue.lei"
        type="text"
        label="LEI-nummer (optioneel)"
        :validation="['notrequired']"
      />
      <customInput
        v-model="modelValue.rsin"
        type="text"
        label="RSIN-nummer (optioneel)"
        :validation="['notrequired']"
      />
    </div>

    <div class="subheader">Correspondentieadres</div>

    <div class="flex-container flex-grow">
      <customInput
        v-model="modelValue.postcode"
        placeholder="1111AA"
        type="text"
        label="Postcode"
        @changed="doZipCall"
      />
      <customInput
        type="text"
        v-model="modelValue.huisnummer"
        label="Huisnummer"
        @changed="doZipCall"
      />
      <customInput
        type="text"
        v-model="modelValue.toevoeging"
        label="Toevoeging"
        @changed="doZipCall"
        :validation="['notrequired']"
      />
    </div>
    <div class="flex-container flex-grow">
      <customInput
        type="text"
        v-model="modelValue.straat"
        label="Straat"
      />
      <customInput
        type="text"
        v-model="modelValue.plaats"
        label="Woonplaats"
      />
      <customInput
        v-model="modelValue.land"
        type="dropdown"
        label="Land"
        :options="allCountries"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntakeCompanyPage',
  emits: ['update:model-value'],
  data() {
    return {
      callTimer: null,
      previousCall: '',
    };
  },
  props: {
    modelValue: Object,
  },
  computed: {
    allCountries() {
      return Object.values(this.$parent.allCountries).reduce((obj, key) => {
        obj.push({
          label: key,
          value: key,
        });
        return obj;
      }, []);
    },
    value() {
      return this.modelValue;
    },
  },
  methods: {
    doZipCall() {
      this.modelValue.postcode = `${this.modelValue.postcode || ''}`.replace(/\s/g, '').toUpperCase();
      const call = `${this.modelValue.land}#${this.modelValue.postcode}#${this.modelValue.huisnummer}#${this.modelValue.toevoeging}`;
      if (
        call !== this.previousCall
        && this.modelValue.postcode
        && this.modelValue.huisnummer
        && this.modelValue.land === 'Nederland'
      ) {
        clearTimeout(this.callTimer);
        this.callTimer = setTimeout(this.zipCall, 1000);
      }
    },
    zipCall() {
      this.sdk.getIntakeZip(
        this.getQueryVariable('intake'),
        this.modelValue.postcode,
        this.modelValue.huisnummer,
        this.modelValue.toevoeging,
        (response) => {
          if (response.status === 200) {
            if (!response.data.exception) {
              this.modelValue.straat = response.data.street;
              this.modelValue.plaats = response.data.city;
              this.$emit('update:model-value', this.value);
            }
          } else {
            // error
          }
        },
      );
    },
  },
};
</script>
